export enum HostType {
  Dev,
  Test,
  Live,
}

export function hostType(): HostType {
  //get the host name
  const hostname = window.location.hostname;

  if (hostname.startsWith('dev')) {
    return HostType.Dev;
  } else if (hostname.startsWith('test')) {
    return HostType.Test;
  } else if (hostname.startsWith('www')) {
    return HostType.Live;
  } else if (hostname.startsWith('firstinmath.ngrok.io')) {
    return HostType.Dev;
  } else if (hostname.startsWith('firstinmath')) {
    return HostType.Live;
  } else if (hostname.startsWith('localhost')) {
    return HostType.Dev;
  } else {
    return HostType.Live;
  }
}

export function isLocalHtmlFile(): boolean {
  return location.href.startsWith('file:') && location.href.endsWith('.html');
}

export function isCdnHtmlFile(): boolean {
  return (
    location.href.indexOf('cdn.firstinmath.com') >= 0 &&
    location.href.endsWith('.html')
  );
}

export function isLocalHost(): boolean {
  return location.href.indexOf('localhost') >= 0;
}

export function fimCdnUrl(src: string) {
  //trim off any leading slash
  if (src[0] == '/') {
    src = src.slice(1);
  }

  //local file, just use the src as is
  if (isLocalHtmlFile()) return src;

  //test html file sourced from the cdn, form the cdn path as dev, because this is testing
  if (isCdnHtmlFile())
    return `https://cdn.firstinmath.com/content/animate/dev/${src}`;

  //if localhost, so FIM, so use the mock local folder
  if (isLocalHost()) return '/cdn/content/animate/' + src;

  //form the cdn path, based on the system type
  return `https://cdn.firstinmath.com/content/animate/${HostType[hostType()].toString().toLowerCase()}/${src}`;
}

export function parseBoolean(
  value: unknown,
  defaultValue: boolean = false,
): boolean {
  if (!value) return defaultValue;

  switch (typeof value) {
    case 'number':
      return value !== 0;

    case 'string':
      return value === '1' || value.toLowerCase() === 'true';

    default:
      return !!value;
  }
}
